/**
 * Shared "home person" for DNA Painter imports, chromosome views, and MRCA auto-assignments.
 * Persisted so Individual modal linking and tree DNA summaries stay aligned.
 */

const STORAGE_KEY = 'geneology-home-person-id';

/** Default matches backend HOME_PERSON_ID for existing deployments. */
export const DEFAULT_HOME_PERSON_ID = '0f31c078-881d-4a37-ac64-ccc36de88772';

export function loadHomePersonId(): string {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v && v.trim()) return v.trim();
  } catch {
    /* ignore */
  }
  return DEFAULT_HOME_PERSON_ID;
}

export function saveHomePersonId(id: string): void {
  try {
    if (!id || !id.trim()) {
      localStorage.removeItem(STORAGE_KEY);
    } else {
      localStorage.setItem(STORAGE_KEY, id.trim());
    }
    window.dispatchEvent(new Event('geneology-home-person-changed'));
  } catch {
    /* ignore quota */
  }
}
